import React from 'react';
import { Button } from '@liquid-spirit/ui-web/button';

const RouteError = () => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div style={{ padding: 24, maxWidth: 720, margin: '64px auto', textAlign: 'center' }}>
      <h2>Something went wrong</h2>
      <p>Sorry, we couldn’t load this page. Please try again.</p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
        <Button secondary onClick={handleBack}>
          Go Back
        </Button>
        <Button primary href="/" style={{ textDecoration: 'none' }}>Go Home</Button>
      </div>
    </div>
  );
};

export default RouteError;
